<script>
    import ContactIcon from './ContactIcon.svelte'
    import SocialIcon from './SocialIcon.svelte'
    export let id;
</script>

<header id="{id}">
    <div class="container mx-auto px-4">
        <div class="flex min-h-screen md:items-center pt-24 md:pt-0 lg:space-x-10">
            <div class="flex-1 hidden lg:flex"></div>
                <div class="flex-1">
                    <div class="flex flex-col space-y-8">
                        <div class="flex-col space-y-4">
                            <span
                                class="
                                inline-block
                                bg-sky-700
                                text-white
                                font-semibold
                                py-2
                                px-8
                                rounded-t-2xl rounded-l-2xl
                                "
                            >
                                Hej
                            </span>
                            <h1 class="text-6xl font-bold">Jeg er Jens Sørensen</h1>
                            <h2 class="text-2xl font-semibold">Full-stack Software Developer</h2>
                        </div>
                        <div class="flex-col space-y-2">
                            <ContactIcon>
                                <svg
                                    slot="icon"
                                    xmlns="http://www.w3.org/2000/svg"
                                    class="h-5 w-5"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                >
                                    <path
                                        d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"
                                    />
                                </svg>
                                <a class="hover:text-sky-700" href="tel+4588741295">
                                    +45 88 74 12 95
                                </a>
                              </ContactIcon>
                              <ContactIcon>
                                <svg 
                                    slot="icon"
                                    xmlns="http://www.w3.org/2000/svg"
                                    class="h-5 w-5"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                    >
                                    <path
                                        fill-rule="evenodd"
                                        d="M14.243 5.757a6 6 0 10-.986 9.284 1 1 0 111.087 1.678A8 8 0 1118 10a3 3 0 01-4.8 2.401A4 4 0 1114 10a1 1 0 102 0c0-1.537-.586-3.07-1.757-4.243zM12 10a2 2 0 10-4 0 2 2 0 004 0z"
                                        clip-rule="evenodd"
                                    />
                                </svg>
                                <a class="hover:text-sky-700" href="mail:info@valt.dk">
                                    info@valt.dk
                                </a>
                              </ContactIcon>
                        </div>
                        <div class="flex space-x-4">
                            <SocialIcon href="https://github.com/jenssoren" title="Github profile">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 496 512"
                                    class="h-5 w-5"
                                >
                                    <path
                                        fill="currentColor"
                                        d="M166 397c0 2-2 4-5 4-4 0-6-1-6-4 0-2 2-3 5-3 3-1 6 1 6 3zm-31-4c-1 2 1 4 4 5s6 0 6-2-1-5-4-5c-3-1-5 0-6 2zm44-2c-3 1-5 3-5 5 1 2 3 3 6 3 3-1 5-3 5-5s-3-3-6-3zM245 8A240 240 0 000 252c0 111 70 206 170 239 12 2 17-5 17-12v-61s-70 15-85-30c0 0-12-29-28-37 0 0-23-15 2-15 0 0 24 2 38 26 22 38 59 27 73 21 2-16 9-28 16-34-56-6-112-14-112-111 0-27 7-41 23-59-2-6-11-33 3-67 21-7 69 27 69 27a237 237 0 01126 0s48-34 69-27c13 34 5 61 2 67 16 18 26 32 26 59 0 97-59 105-115 111 9 8 17 23 17 46v84c0 6 5 14 17 12a248 248 0 00168-239C496 113 384 8 245 8zM97 353c-1 1-1 3 1 5 1 2 4 2 5 1s1-3-1-5c-1-2-4-2-5-1zm-11-8l3 4c1 1 3 0 4-1s0-3-2-4-4 0-5 1zm33 35c-2 2-1 5 1 7s5 2 7 1c1-2 0-5-2-7s-5-2-6-1zm-12-14v6c2 2 5 3 6 2 2-1 2-4 0-6-1-3-4-4-6-2z"
                                    />
                                </svg>
                              </SocialIcon>
                              <SocialIcon href="https://www.linkedin.com/in/jenssoren" title="LinkedIn account">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 448 512"
                                  class="h-5 w-5"
                                >
                                  <path
                                    fill="currentColor"
                                    d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"
                                  />
                                </svg>
                              </SocialIcon>
                              <SocialIcon href="mailto:info@valt.dk" title="Mail">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="h-5 w-5"
                                  viewBox="0 0 20 20"
                                  fill="currentColor"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    d="M14.243 5.757a6 6 0 10-.986 9.284 1 1 0 111.087 1.678A8 8 0 1118 10a3 3 0 01-4.8 2.401A4 4 0 1114 10a1 1 0 102 0c0-1.537-.586-3.07-1.757-4.243zM12 10a2 2 0 10-4 0 2 2 0 004 0z"
                                    clip-rule="evenodd"
                                  />
                                </svg>
                              </SocialIcon>
                        </div>
                    </div>
                </div>
        </div>
    </div>
</header>